import type { ButtonConfig } from '../../declare'
import { useMemo, useContext } from 'react'
import { EasyModal, EasyIcon, EditPage, TreeContext } from 'src/components'

type Props = {
  config: ButtonConfig
}

const EditModalBtn = (props: Props) => {
  const tree = useContext(TreeContext)

  const formData = useMemo(() => {
    const { __RECORD__: record } = props.config
    return { formId: record.ID }
  }, [props.config.__RECORD__])

  const { LABEL, ICON, FORM_CODE, WIDTH } = props.config
  const formCode = FORM_CODE || tree.treeConfig.Nav_Form?.CODE
  return (
    <EasyModal
      modal={{ title: formCode, width: WIDTH }}
      slot={<EasyIcon title={LABEL} type={ICON} defaultIcon='EditOutlined' />}
    >
      <EditPage formCode={formCode} formData={formData} />
    </EasyModal>
  )
}

export default EditModalBtn